import { AlertTriangle } from "lucide-react";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { useSubscriptionStatus } from "@/hooks/use-payments";
import {
  isSubscriptionOpenPath,
  subscriptionGateDecision,
  subscriptionNotice,
} from "@/lib/subscriptionGate";
import { PageGuidancePanel } from "@/components/guidance/PageGuidancePanel";

export function SubscriptionGate() {
  const location = useLocation();
  const openPath = isSubscriptionOpenPath(location.pathname);
  const statusQuery = useSubscriptionStatus({ enabled: !openPath });

  if (openPath) {
    return (
      <>
        <PageGuidancePanel />
        <Outlet />
      </>
    );
  }

  // CALL-04 (2026-10-26): fail CLOSED. See `subscriptionGateDecision`.
  const decision = subscriptionGateDecision(location, {
    status: statusQuery.isPending ? "pending" : statusQuery.isError ? "error" : "success",
    data: statusQuery.data,
  });
  if (decision.kind === "wait") {
    return (
      <div
        className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground"
        role="status"
      >
        Checking subscription status…
      </div>
    );
  }
  if (decision.kind === "redirect") return <Navigate to={decision.to} replace />;

  const notice =
    statusQuery.data?.status === "past_due" ? subscriptionNotice(statusQuery.data.status) : null;

  return (
    <>
      {notice && (
        <div
          className="mb-4 flex gap-3 rounded-xl border border-warning/40 bg-warning/10 p-4"
          role="alert"
        >
          <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-warning" />
          <div>
            <p className="text-sm font-semibold text-foreground">{notice.title}</p>
            <p className="mt-0.5 text-sm text-muted-foreground">
              {notice.body}{" "}
              <Link className="font-medium text-primary hover:underline" to="/payment">
                Manage billing
              </Link>
            </p>
          </div>
        </div>
      )}
      <PageGuidancePanel />
      <Outlet />
    </>
  );
}
